import React from 'react'
import './index.css'
import Flex from 'components/Flex'
import TextSemiBold from 'components/TextSemiBold'
import InfoIcon from 'components/Icons/InfoIcon'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import openSidebarSubscriptionsAction from 'modules/subscription/redux/actions/open-sidebar'
import useDispatch from 'hooks/use-dispatch'
import Button from 'components/Button'
import VerticalSeparator from 'components/VerticalSeparator'

const ANALYTICS_EVENT = {
  LEARN_MORE_ABOUT_SUBSCRIPTIONS_IN_PDP: 'LEARN_MORE_ABOUT_SUBSCRIPTIONS_IN_PDP',
  LEARN_MORE_ABOUT_SUBSCRIPTIONS_IN_QUICK_SHOP: 'LEARN_MORE_ABOUT_SUBSCRIPTIONS_IN_QUICK_SHOP'
}

const DELIVERY = 'Delivery'
const LEARN_MORE = 'Learn more about subscriptions'
const LEARN_MORE_SHORT = 'Learn about subscriptions'

/**
 * @param props
 * @param props.isShort
 * @param props.isFromQuickShop
 * @return {JSX.Element}
 * @constructor
 */
export default function ProductSubscribeAndSaveDeliveryLabel (props) {
  const {
    isShort,
    isFromQuickShop
  } = props
  logUtil('ProductSubscribeAndSaveDeliveryLabel').debug('[start] props=', props)
  const dispatch = useDispatch()

  const debugProps = {}
  logUtil('ProductSubscribeAndSaveDeliveryLabel').debug('debugProps=', debugProps)

  const handleClick = () => {
    logUtil('ProductSubscribeAndSaveDeliveryLabel#handleClick').debug('[start]')
    logEventAnalyticsUtil(
      isFromQuickShop
        ? ANALYTICS_EVENT.LEARN_MORE_ABOUT_SUBSCRIPTIONS_IN_QUICK_SHOP
        : ANALYTICS_EVENT.LEARN_MORE_ABOUT_SUBSCRIPTIONS_IN_PDP
    )
    dispatch(
      openSidebarSubscriptionsAction()
    )
  }

  return (
    <Flex
      className='product-subscribe-and-save-delivery-label'
    >
      <TextSemiBold
        className='product-subscribe-and-save-delivery-label-title'
      >
        {DELIVERY}
      </TextSemiBold>

      {
        !!isShort && (
          <VerticalSeparator />
        )
      }

      <Button
        className='learn-more-about-subscriptions'
        onClick={handleClick}
      >
        <InfoIcon />
        <span>{isShort ? LEARN_MORE_SHORT : LEARN_MORE}</span>
      </Button>
    </Flex>
  )
}
